// TaminRedirect.tsx
import React, { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
import { localStorageSet } from "../../../utils/localStorage";

const TaminRedirect = () => {
  // const navigate = useNavigate();

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code") || "";
      const state = params.get("state") || "";
      const expires_in = params.get("expires_in") || "";

      if (!code || !state) {
        // Handle error case if Tamin redirected back without code/state (e.g., user canceled or error occurred)
        const error = params.get("error");
        const errorDescription = params.get("error_description");

        const errorPayload = {
          type: "tamin_auth_error",
          error: error || "missing_code",
          description:
            errorDescription || "Authentication failed or cancelled.",
        };
        console.error("TAMIN_REDIRECT_ERROR:", errorPayload);

        if (window.opener && !window.opener.closed) {
          // Notify opener of the error
          window.opener.postMessage(errorPayload, window.location.origin);
        }

        // Wait and close
        setTimeout(() => window.close(), 400);
        return;
      }

      // You may also parse authorizationCode in path segments if needed:
      // const pathSegments = window.location.pathname.split('/').filter(Boolean);

      const payload = {
        type: "tamin_auth",
        code,
        state,
        expires_in,
        // optionally other info from path/query
      };

      // Option A (recommended): send to opener window
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(payload, window.location.origin);
      }

      // Also store locally (fallback)
      localStorageSet("TAMIN_REDIRECT_PAYLOAD", payload);

      // Optionally exchange code for token here by calling your backend endpoint,
      // then postMessage the full token to opener instead of raw code.
    } catch (e) {
      console.error("Tamin redirect error", e);
      // still try to close
      // setTimeout(() => window.close(), 1000);
    } finally {
      // بستن پاپ‌آپ
      // Close popup after short delay to allow opener to receive message
      setTimeout(() => {
        window.close();
      }, 5000); // 400 میلی‌ثانیه برای اطمینان از ارسال postMessage
    }
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <h3>در حال تکمیل ورود...</h3>
      <p>لطفا تا بسته شدن پنجره صبر کنید.</p>
    </div>
  );
};

export default TaminRedirect;

// const TaminRedirect = () => {

//   return (
//     <div>
//       با موفقیت انجام شد
//     </div>
//   )
// }

// export default TaminRedirect;
